import * as React from "react"

import { cn } from "@/lib/utils"

export function ToolbarSurface({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "flex items-center gap-4 bg-white/60 p-2 rounded-xl border border-white/50 shadow-sm backdrop-blur-sm",
        className
      )}
      {...props}
    />
  )
}
